import Cookies from 'universal-cookie'

const cookies = new Cookies()
// const defaultDomain = '.erosuniverse.com'
const defaultPath = '/'
const defaultOptions = {
    //  domain: defaultDomain,
    path: defaultPath,
    sameSite: 'none',
    secure: true
}

export function setCookie(key, value, cookieOptions = {}) {
    const options = { ...defaultOptions, ...cookieOptions }
    if (typeof window !== 'undefined') {
        cookies.set(key, value, options)
    }
}

export function removeCookie(key, cookieOptions = {}) {
    const options = { ...defaultOptions, ...cookieOptions }
    if (typeof window !== 'undefined') {
        cookies.remove(key, options)
    }
}

export function getCookie(key) {
    if (typeof window !== 'undefined') {
        return cookies.get(key)
    } else {
        return undefined
    }
}
